/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as SchemaTypes from '../schema/types'
import * as UtilityTypes from '../utilities/types'

import * as LoantapeTypes from './types'

export type LoanTapeTypesListKey = [
  'companies',
  string | undefined,
  'loan-tape-types',
  unknown,
]

export type LoanTapeTypesListResponse =
  LoantapeTypes.ResponseLoanTapeTypePagingResponse

export type LoanTapeTypesListVariables = {
  companyId: string | undefined
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
  }
}

export const loanTapeTypesList = makeData<
  LoanTapeTypesListResponse,
  LoanTapeTypesListKey,
  LoanTapeTypesListVariables
>({
  method: 'get',
  name: 'loanTapeTypesList',
  summary: 'Get loan tape types',
  path: '/companies/{companyId}/loan-tape-types',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'loan-tape-types',
    query,
  ],
})

export type LoanTapeTypeCreateKey = [
  'companies',
  string | undefined,
  'loan-tape-types',
  unknown,
]

export type LoanTapeTypeCreateResponse =
  LoantapeTypes.ResponseLoanTapeTypeResponse

export type LoanTapeTypeCreateVariables = {
  companyId: string | undefined
  body?: LoantapeTypes.RequestBodyLoanTapeTypePost
  query?: void
}

export const loanTapeTypeCreate = makeData<
  LoanTapeTypeCreateResponse,
  LoanTapeTypeCreateKey,
  LoanTapeTypeCreateVariables
>({
  method: 'post',
  name: 'loanTapeTypeCreate',
  summary: 'Create loan tape type',
  path: '/companies/{companyId}/loan-tape-types',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'loan-tape-types',
    query,
  ],
})

export type LoanTapeTypeGetKey = [
  'companies',
  string | undefined,
  'loan-tape-types',
  string | undefined,
  unknown,
]

export type LoanTapeTypeGetResponse = LoantapeTypes.ResponseLoanTapeTypeResponse

export type LoanTapeTypeGetVariables = {
  companyId: string | undefined
  loanTapeTypeId: string | undefined
  body?: void
  query?: void
}

export const loanTapeTypeGet = makeData<
  LoanTapeTypeGetResponse,
  LoanTapeTypeGetKey,
  LoanTapeTypeGetVariables
>({
  method: 'get',
  name: 'loanTapeTypeGet',
  summary: 'Get loan tape type by ID',
  path: '/companies/{companyId}/loan-tape-types/{loanTapeTypeId}',
  queryKey: ({ query, companyId, loanTapeTypeId }) => [
    'companies',
    companyId,
    'loan-tape-types',
    loanTapeTypeId,
    query,
  ],
})

export type LoanTapeTypeUpdateKey = [
  'companies',
  string | undefined,
  'loan-tape-types',
  string | undefined,
  unknown,
]

export type LoanTapeTypeUpdateResponse =
  LoantapeTypes.ResponseLoanTapeTypeResponse

export type LoanTapeTypeUpdateVariables = {
  companyId: string | undefined
  loanTapeTypeId: string | undefined
  body?: LoantapeTypes.RequestBodyLoanTapeTypePut
  query?: void
}

export const loanTapeTypeUpdate = makeData<
  LoanTapeTypeUpdateResponse,
  LoanTapeTypeUpdateKey,
  LoanTapeTypeUpdateVariables
>({
  method: 'put',
  name: 'loanTapeTypeUpdate',
  summary: 'Update loan tape type',
  path: '/companies/{companyId}/loan-tape-types/{loanTapeTypeId}',
  queryKey: ({ query, companyId, loanTapeTypeId }) => [
    'companies',
    companyId,
    'loan-tape-types',
    loanTapeTypeId,
    query,
  ],
})

export type LoanTapeTypeDeleteKey = [
  'companies',
  string | undefined,
  'loan-tape-types',
  string | undefined,
  unknown,
]

export type LoanTapeTypeDeleteResponse = void

export type LoanTapeTypeDeleteVariables = {
  companyId: string | undefined
  loanTapeTypeId: string | undefined
  body?: void
  query?: void
}

export const loanTapeTypeDelete = makeData<
  LoanTapeTypeDeleteResponse,
  LoanTapeTypeDeleteKey,
  LoanTapeTypeDeleteVariables
>({
  method: 'delete',
  name: 'loanTapeTypeDelete',
  summary: 'Delete loan tape type',
  path: '/companies/{companyId}/loan-tape-types/{loanTapeTypeId}',
  queryKey: ({ query, companyId, loanTapeTypeId }) => [
    'companies',
    companyId,
    'loan-tape-types',
    loanTapeTypeId,
    query,
  ],
})

export type LoanTapeTypeDataKey = [
  'companies',
  string | undefined,
  'loan-tape-types',
  string | undefined,
  'data',
  unknown,
]

export type LoanTapeTypeDataResponse = UtilityTypes.SingletonResponse & {
  /**
   * Row data for this loan (for loan tape types — usually one row per loan, plus one
   * per draw when line-of-credit draws are reported separately) or for its payments
   * (for payment tape types). Fields on each row follow the `fields` attribute on the
   * loan tape type. Omitted when `missingSnapshot` is `true`. Empty when the loan
   * should not be snapshotted for this date (e.g., the loan has not started yet).
   */
  data?: Array<{
    [key: string]: any
  }>
  /**
   * `true` when the loan snapshot required to render this tape row does not exist for the
   * given report date. Only set when the loan tape type's `actionOnMissingData` is
   * `excludeFromTape` (otherwise a row is returned with `dataStatus=missingData`). The tape
   * worker uses this flag to retry the chunk and page oncall if the snapshot never arrives.
   */
  missingSnapshot?: boolean
  /**
   * `true` when the loan tape type is configured with `actionOnMissingData=excludeFromTape`
   * and the snapshot is missing. Signals to the tape worker that the loan should be dropped
   * from the tape output after the retry window elapses, rather than failing the chunk.
   */
  excludeFromTape?: boolean
}

export type LoanTapeTypeDataVariables = {
  companyId: string | undefined
  loanTapeTypeId: string | undefined
  body?: void
  query?: {
    loanId: string
    reportDate?: string
    investorId?: SchemaTypes.AnyId
    paymentsFromTime?: string
    paymentsToTime?: string
  }
}

export const loanTapeTypeData = makeData<
  LoanTapeTypeDataResponse,
  LoanTapeTypeDataKey,
  LoanTapeTypeDataVariables
>({
  method: 'get',
  name: 'loanTapeTypeData',
  summary: 'Get loan tape data for loan',
  path: '/companies/{companyId}/loan-tape-types/{loanTapeTypeId}/data',
  queryKey: ({ query, companyId, loanTapeTypeId }) => [
    'companies',
    companyId,
    'loan-tape-types',
    loanTapeTypeId,
    'data',
    query,
  ],
})

export type LoanTapesListKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  unknown,
]

export type LoanTapesListResponse = LoantapeTypes.ResponseLoanTapePagingResponse

export type LoanTapesListVariables = {
  companyId: string | undefined
  body?: void
  query?: {
    untokenize?: boolean
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
  }
}

export const loanTapesList = makeData<
  LoanTapesListResponse,
  LoanTapesListKey,
  LoanTapesListVariables
>({
  method: 'get',
  name: 'loanTapesList',
  summary: 'Get loan tapes',
  path: '/companies/{companyId}/loan-tapes',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'loan-tapes',
    query,
  ],
})

export type LoanTapeCreateKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  unknown,
]

export type LoanTapeCreateResponse = LoantapeTypes.ResponseLoanTapeResponse

export type LoanTapeCreateVariables = {
  companyId: string | undefined
  body?: LoantapeTypes.RequestBodyLoanTapePost
  query?: void
}

export const loanTapeCreate = makeData<
  LoanTapeCreateResponse,
  LoanTapeCreateKey,
  LoanTapeCreateVariables
>({
  method: 'post',
  name: 'loanTapeCreate',
  summary: 'Create loan tape',
  path: '/companies/{companyId}/loan-tapes',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'loan-tapes',
    query,
  ],
})

export type LoanTapesGenerateKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  'generate',
  unknown,
]

export type LoanTapesGenerateResponse =
  LoantapeTypes.ResponseLoanTapeGeneratePostResponse

export type LoanTapesGenerateVariables = {
  companyId: string | undefined
  body?: LoantapeTypes.RequestBodyLoanTapeGeneratePost
  query?: void
}

export const loanTapesGenerate = makeData<
  LoanTapesGenerateResponse,
  LoanTapesGenerateKey,
  LoanTapesGenerateVariables
>({
  method: 'post',
  name: 'loanTapesGenerate',
  summary: 'Generate Loan Tapes',
  path: '/companies/{companyId}/loan-tapes/generate',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'loan-tapes',
    'generate',
    query,
  ],
})

export type LoanTapeGetKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  string | undefined,
  unknown,
]

export type LoanTapeGetResponse = LoantapeTypes.ResponseLoanTapeResponse

export type LoanTapeGetVariables = {
  companyId: string | undefined
  loanTapeId: string | undefined
  body?: void
  query?: {
    untokenize?: boolean
  }
}

export const loanTapeGet = makeData<
  LoanTapeGetResponse,
  LoanTapeGetKey,
  LoanTapeGetVariables
>({
  method: 'get',
  name: 'loanTapeGet',
  summary: 'Get loan tape by ID',
  path: '/companies/{companyId}/loan-tapes/{loanTapeId}',
  queryKey: ({ query, companyId, loanTapeId }) => [
    'companies',
    companyId,
    'loan-tapes',
    loanTapeId,
    query,
  ],
})

export type LoanTapeUpdateKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  string | undefined,
  unknown,
]

export type LoanTapeUpdateResponse = LoantapeTypes.ResponseLoanTapeResponse

export type LoanTapeUpdateVariables = {
  companyId: string | undefined
  loanTapeId: string | undefined
  body?: LoantapeTypes.RequestBodyLoanTapePut
  query?: void
}

export const loanTapeUpdate = makeData<
  LoanTapeUpdateResponse,
  LoanTapeUpdateKey,
  LoanTapeUpdateVariables
>({
  method: 'put',
  name: 'loanTapeUpdate',
  summary: 'Update loan tape',
  path: '/companies/{companyId}/loan-tapes/{loanTapeId}',
  queryKey: ({ query, companyId, loanTapeId }) => [
    'companies',
    companyId,
    'loan-tapes',
    loanTapeId,
    query,
  ],
})

export type LoanTapeDeleteKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  string | undefined,
  unknown,
]

export type LoanTapeDeleteResponse = void

export type LoanTapeDeleteVariables = {
  companyId: string | undefined
  loanTapeId: string | undefined
  body?: void
  query?: void
}

export const loanTapeDelete = makeData<
  LoanTapeDeleteResponse,
  LoanTapeDeleteKey,
  LoanTapeDeleteVariables
>({
  method: 'delete',
  name: 'loanTapeDelete',
  summary: 'Delete loan tape',
  path: '/companies/{companyId}/loan-tapes/{loanTapeId}',
  queryKey: ({ query, companyId, loanTapeId }) => [
    'companies',
    companyId,
    'loan-tapes',
    loanTapeId,
    query,
  ],
})

export type GetAllLoansForLoanTapeKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  string | undefined,
  'loans',
  unknown,
]

export type GetAllLoansForLoanTapeResponse = UtilityTypes.Paging & {
  data?: Array<{
    /** Loan identifier */
    id?: string
  }>
}

export type GetAllLoansForLoanTapeVariables = {
  companyId: string | undefined
  loanTapeId: string | undefined
  body?: void
  query?: {
    reportDate?: string
    loanTypeId: SchemaTypes.AnyId
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
  }
}

export const getAllLoansForLoanTape = makeData<
  GetAllLoansForLoanTapeResponse,
  GetAllLoansForLoanTapeKey,
  GetAllLoansForLoanTapeVariables
>({
  method: 'get',
  name: 'getAllLoansForLoanTape',
  summary: 'Get loan tape loans',
  path: '/companies/{companyId}/loan-tapes/{loanTapeId}/loans',
  queryKey: ({ query, companyId, loanTapeId }) => [
    'companies',
    companyId,
    'loan-tapes',
    loanTapeId,
    'loans',
    query,
  ],
})

export type LoanTapesDueKey = ['loan-tapes', 'due', unknown]

export type LoanTapesDueResponse = LoantapeTypes.ResponseLoanTapePagingResponse

export type LoanTapesDueVariables = {
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
    timezone?: string | null
  }
}

export const loanTapesDue = makeData<
  LoanTapesDueResponse,
  LoanTapesDueKey,
  LoanTapesDueVariables
>({
  method: 'get',
  name: 'loanTapesDue',
  summary: 'Get all due loan tapes for the given day',
  path: '/loan-tapes/due',
  queryKey: ({ query }) => ['loan-tapes', 'due', query],
})

export type LoanTapeRecordsListKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  string | undefined,
  'records',
  unknown,
]

export type LoanTapeRecordsListResponse =
  LoantapeTypes.ResponseLoanTapeRecordPagingResponse

export type LoanTapeRecordsListVariables = {
  companyId: string | undefined
  loanTapeId: string | undefined
  body?: void
  query?: void
}

export const loanTapeRecordsList = makeData<
  LoanTapeRecordsListResponse,
  LoanTapeRecordsListKey,
  LoanTapeRecordsListVariables
>({
  method: 'get',
  name: 'loanTapeRecordsList',
  summary: 'Get loan tape records',
  path: '/companies/{companyId}/loan-tapes/{loanTapeId}/records',
  queryKey: ({ query, companyId, loanTapeId }) => [
    'companies',
    companyId,
    'loan-tapes',
    loanTapeId,
    'records',
    query,
  ],
})

export type LoanTapeRecordCreateKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  string | undefined,
  'records',
  unknown,
]

export type LoanTapeRecordCreateResponse =
  LoantapeTypes.ResponseLoanTapeRecordResponse

export type LoanTapeRecordCreateVariables = {
  companyId: string | undefined
  loanTapeId: string | undefined
  body?: LoantapeTypes.RequestBodyLoanTapeRecord
  query?: {
    forceReplace?: boolean
  }
}

export const loanTapeRecordCreate = makeData<
  LoanTapeRecordCreateResponse,
  LoanTapeRecordCreateKey,
  LoanTapeRecordCreateVariables
>({
  method: 'post',
  name: 'loanTapeRecordCreate',
  summary: 'Create loan tape record',
  path: '/companies/{companyId}/loan-tapes/{loanTapeId}/records',
  queryKey: ({ query, companyId, loanTapeId }) => [
    'companies',
    companyId,
    'loan-tapes',
    loanTapeId,
    'records',
    query,
  ],
})

export type LoanTapeRecordUpdateKey = [
  'companies',
  string | undefined,
  'loan-tapes',
  string | undefined,
  'records',
  string | undefined,
  unknown,
]

export type LoanTapeRecordUpdateResponse =
  LoantapeTypes.ResponseLoanTapeRecordResponse

export type LoanTapeRecordUpdateVariables = {
  companyId: string | undefined
  loanTapeId: string | undefined
  loanTapeRecordId: string | undefined
  body?: LoantapeTypes.RequestBodyLoanTapeRecord
  query?: void
}

export const loanTapeRecordUpdate = makeData<
  LoanTapeRecordUpdateResponse,
  LoanTapeRecordUpdateKey,
  LoanTapeRecordUpdateVariables
>({
  method: 'put',
  name: 'loanTapeRecordUpdate',
  summary: 'Update loan tape record',
  path: '/companies/{companyId}/loan-tapes/{loanTapeId}/records/{loanTapeRecordId}',
  queryKey: ({ query, companyId, loanTapeId, loanTapeRecordId }) => [
    'companies',
    companyId,
    'loan-tapes',
    loanTapeId,
    'records',
    loanTapeRecordId,
    query,
  ],
})
